import { MapDispatchToPropsFunction } from 'react-redux'
import * as get from 'lodash/get'
import SocialProfileInfo, {
  SocialProfileInfoStateProps,
  SocialProfileInfoDispatchProps,
  SocialProfileInfoOwnProps,
} from 'components/features/socialFeed/SocialProfileInfo/SocialProfileInfo'
import { State } from 'interfaces/state'
import { FORM_SOCIAL_PROFILE } from 'constants/forms'
import { getFormValues } from 'redux-form'
import { changeSocialProfileStepActionCreator } from 'actions/feedActions'
import { SocialProfileFormValues } from 'interfaces/feed'
import { memberFeedInfoSelector } from 'selectors/feedSelectors'
import { connectOptionally, OptionalRendererProps, NO_RENDER, createPositiveRendererProps } from 'tangle-shared'
import { userImageSelector } from 'selectors/userImagesSelectors'

const formValuesSelector = getFormValues<SocialProfileFormValues>(FORM_SOCIAL_PROFILE)
const mapStateToProps = (state: State, ownProps: SocialProfileInfoOwnProps): OptionalRendererProps<SocialProfileInfoStateProps> => {
  if (ownProps.readonly) {
    const memberFeed = memberFeedInfoSelector(state)
    if (!memberFeed) {
      return NO_RENDER()
    }

    return createPositiveRendererProps({
      username: memberFeed.username || '',
      avatar: null,
    })
  }

  const formValues = formValuesSelector(state)
  const username = get(formValues, 'username', '')
  const avatarId = get(formValues, 'avatar', null)
  const avatar = avatarId ? userImageSelector(state, avatarId) : null

  return createPositiveRendererProps({
    username,
    avatar,
  })
}

const mapDispatchToProps: MapDispatchToPropsFunction<SocialProfileInfoDispatchProps, SocialProfileInfoOwnProps> = (dispatch) => ({
  onEdit: () => dispatch(changeSocialProfileStepActionCreator('form')),
})

const SocialProfileInfoContainer = connectOptionally<
  SocialProfileInfoStateProps, SocialProfileInfoDispatchProps, SocialProfileInfoOwnProps
>(mapStateToProps, mapDispatchToProps)(SocialProfileInfo)

export default SocialProfileInfoContainer
